export default "__VITE_ASSET__c57d3d68__"